//FAQ Component
import React from 'react';
import { connect } from 'react-redux';
import '../../stylesheets/custom.css';

class Faq extends React.Component {
    constructor(props, context) {
        super(props, context);

    }
    render() {
        return <div>
            <div class="faq">
                <h1>FAQ</h1>
                <p><strong>Why Neighbourhood dashboard?</strong></p>
                <p>To make data available to citizens to aid them in their interactions with the local government. We also expect that by providing a platform to display civic and environmental problems, we will also be able to solve them</p>

                <p><strong>Who are you guys?</strong></p>
                <p>We are Reap Benefit. We have created a network of about 24,000 Solve Ninjas - school students in the age group of 12-18 - who solve civic and environmental issues through a process we call DISS (Discover, Investigate, Solve, Share)</p>
                <p> </p>
                <p><strong>How do i become a Solve Ninja?</strong></p>
                <p>It’s quite simple. Go to the dashboard, you’ll have a set of problems in your neighbourhood that you can solve. Then you go out and solve the problem.</p>
                <p>If you need help do contact us - Download our app “Solve Ninja” to connect with us easily.</p>

                <p><strong>You guys are cool! I’d like to intern with you guys! Who do i talk to?</strong></p>
                <p>We’re always looking for interns and volunteers! Mail us at <u>careers@reapbenefit.org</u> for more details</p>

                <p><strong>I’d like to get to know you guys better! How do I do it?</strong></p>
                <p>We get this all the time! Relax! We’re used to it - just mail us at <u>info@reapbenefit.org</u></p>

            </div >
        </div >;
    }
}
export default Faq;



// WEBPACK FOOTER //
// ./src/components/category/faq.js